import React from 'react';

const SectionHeading = ({
  title,
  subtitle,
  cta,
  align = 'center',
  className = '',
  titleClassName = '',
  tag,
}) => {
  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  return (
    <div className={`mb-10 md:mb-14 ${alignClasses[align]} ${className}`}>
      {tag && (
        <span className="inline-block px-3 py-1 mb-4 text-sm font-semibold text-brand-500 bg-brand-100 rounded-pill">
          {tag}
        </span>
      )}
      <h2 className={`text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-[var(--color-text-primary)] text-balance ${titleClassName}`}>
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-lg text-[var(--color-text-secondary)] max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
      {cta && <div className="mt-6">{cta}</div>}
    </div>
  );
};

export default SectionHeading;
